import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";


function Latest() {
  const data = [
    {
      id: 1,
      name: "Life Insurance",
      img: "assets/images/portfolio/portfolio-1-1.jpg",
    },
    {
      id: 2,
      name: "Health Insurance",
      img: "assets/images/portfolio/portfolio-1-2.jpg",
    },
    {
      id: 3,
      name: "House Insurance",
      img: "assets/images/portfolio/portfolio-1-3.jpg",
    },
    {
      id: 4,
      name: "Car Insurance",
      img: "assets/images/portfolio/portfolio-1-4.jpg",
    },
    {
      id: 5,
      name: "Study Insurance",
      img: "assets/images/portfolio/portfolio-1-5.jpg",
    },
    {
      id: 6,
      name: "Family Insurance",
      img: "assets/images/portfolio/portfolio-1-6.jpg",
    },
    {
      id: 7,
      name: "Car Insurance",
      img: "assets/images/portfolio/portfolio-1-7.jpg",
    },
    {
      id: 8,
      name: "Life Insurance",
      img: "assets/images/portfolio/portfolio-1-8.jpg",
    },
    {
      id: 9,
      name: "Business Insurance",
      img: "assets/images/portfolio/portfolio-1-9.jpg",
    },
  ];

  return (
    <>
      <section className="portfolio-grid">
        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__tagline">latest project</p>
            <h3 className="sec-title__title">Related Projects</h3>
          </div>

          <Swiper
            spaceBetween={30}
            slidesPerView={1}
            loop={true}
            breakpoints={{
              576: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
          >
            {data.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="portfolio-card">
                  <div className="portfolio-card__image">
                    <img src={item.img} alt={item.name} />
                    <div className="portfolio-card__content">
                      <span className="portfolio-card__tagline">Insurance</span>
                      <h3 className="portfolio-card__title">
                        <Link to="/portfoliodetails">{item.name}</Link>
                      </h3>
                      <Link
                        to="/portfoliodetails"
                        className="portfolio-card__link"
                      >
                        <i className="far fa-arrow-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </>
  );
}

export default Latest;
